import type {
  GetFeaturesInnerParams,
  ModalProps,
} from '@/app/components/search/components/Card/Details/Features/getFeatures/types.ts';
import { getPackageSavings } from '@/app/components/search/components/Modal/Modals/PackageSavingsModal/getPackageSavings.tsx';
import { getAdultsChildrenCount } from '@/utils/peopleUtils.ts';
import { type Feature, FeatureType } from '@/app/components/search/components/Card/utils/facilitiesTypes.ts';
import React from 'react';
import dynamic from 'next/dynamic';
import { formatPrice } from '@/app/components/search/utils/formatting.ts';

export const PackageSavingsModal = dynamic(() => import('../../../../../Modal/Modals/PackageSavingsModal'), {
  ssr: false,
});

export const getPackageSavingsFeature = ({
  hasPackageSavings,
  packageSavingsUspEnabled,
  dealCard,
  localization,
  t,
  searchParams,
}: GetFeaturesInnerParams): Feature[] => {
  if (!hasPackageSavings || !packageSavingsUspEnabled || !dealCard) return [];

  const label = t('vacation.oss.cards.usp.package_discount');
  const { totalSavings } = getPackageSavings(dealCard, localization);

  if (!label || !totalSavings) return [];

  const travellersCount = getAdultsChildrenCount(searchParams) || 1;
  const amount = formatPrice({ price: totalSavings / travellersCount, localization });
  const text = label.replace('__amount__', amount).replace(/\*(.*?)\*/g, '<b>$1</b>');

  return [
    {
      icon: undefined,
      text,
      className: 'package-discount-usp',
      featureType: FeatureType.normal,
      iconRight: { category: 'Semantics', name: 'icon-circle-info', color: 'iconSecondary' } as const,
      Modal: ({ isOpen, onClose }: ModalProps) => (
        <PackageSavingsModal isOpen={isOpen} onClose={onClose} dealCard={dealCard} />
      ),
    },
  ];
};
